import { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { Search, TerminalSquare } from "lucide-react";
import { Input } from "@/components/ui/input";

export default function CommandReference() {
  const [commands, setCommands] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/commands").then((r) => setCommands(r.data.commands)).catch(() => {});
  }, []);

  const filtered = useMemo(() => {
    const t = q.trim().toLowerCase();
    if (!t) return commands;
    return commands.filter(
      (c) => c.name.includes(t) || c.desc.toLowerCase().includes(t) || c.category.toLowerCase().includes(t)
    );
  }, [q, commands]);

  return (
    <div className="p-8 max-w-5xl mx-auto">
      <div className="flex items-center gap-3">
        <TerminalSquare className="h-6 w-6 text-primary" />
        <h1 className="font-display font-bold text-3xl tracking-tight">Command Reference</h1>
      </div>
      <p className="text-muted-foreground mt-1">Searchable library of the commands used across the labs.</p>

      <div className="relative mt-6 max-w-md">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          data-testid="command-search"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search commands, e.g. grep, permissions…"
          className="pl-9"
        />
      </div>

      <div className="mt-6 grid sm:grid-cols-2 gap-3">
        {filtered.map((c) => (
          <div key={c.name} className="rounded-lg border border-border bg-card p-4" data-testid={`cmd-${c.name}`}>
            <div className="flex items-center justify-between">
              <code className="font-mono font-bold text-primary text-base">{c.name}</code>
              <span className="text-[10px] uppercase tracking-widest text-muted-foreground">{c.category}</span>
            </div>
            <p className="text-sm text-muted-foreground mt-2">{c.desc}</p>
            <div className="mt-3 font-mono text-xs bg-[#0b1020] text-emerald-300 rounded px-3 py-2 overflow-x-auto">
              $ {c.example}
            </div>
          </div>
        ))}
        {filtered.length === 0 && <div className="text-muted-foreground text-sm">No commands match “{q}”.</div>}
      </div>
    </div>
  );
}
